import { TextField } from "@mui/material";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DivMain, Btn, Conteiner, Form } from "../../components/Conteiner";
import { IFormValue, UserContexts } from "../../Context/UserContexts";
import Logo from '../../img/Logo.png';
import api from "../../services/api";


function Login() {

const { register, handleSubmit } = useForm<IFormValue>();
const { fsetiten } = useContext(UserContexts);
const navigate = useNavigate();


const loginApi = (dataLogin:IFormValue) =>{
  console.log(dataLogin);
  api.post('/sessions', dataLogin)
  .then((response)=>{
    fsetiten(response.data.user);

    window.localStorage.clear();
    window.localStorage.setItem("KenzieHub-auth", response.data.token);
    toast.success("Dados corretos, aguarde...");
    navigate('/dashboard', { replace: true });

  })
  .catch((err)=>{
    console.error(err)
  });
};


  return( 
    <>
      <DivMain>
        <img src={Logo} alt="logo kenzieHub" />
        <Conteiner>
          <Form onSubmit={handleSubmit(loginApi)} >
            <h1>Login</h1>
            <TextField  placeholder="Digite seu email" autoComplete="off"
            label="email"  {...register("email")}></TextField>

            <TextField type='password'  placeholder="Digite sua senha"
            label="Senha"  {...register("password")}></TextField>
            
            <div>
              <Btn color={`#FF577F`} type='submit'>Enviar</Btn>
              <span>Ainda não possui uma conta?</span>
              <Link to={`/cadastro`}>Cadastre-se</Link>
            </div>
          </Form>
        </Conteiner>
      </DivMain>
    </>
  );
}

export default Login;